import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  tasks,
  bag,
}

// 背包列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35750100
export const knapsack_list = createAsyncThunk(
  'LudoSkin_knapsack_list',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'tips'>>
    >(
      '/gamestore/common/knapsack_list',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 冷启活动任务列表 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35750600
export const cold_boot_activity = createAsyncThunk(
  'LudoSkin_cold_boot_activity',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'cold_boot_activity' | 'activity_time'>>
    >(
      '/gamestore/ludo/cold_boot_activity',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 使用皮肤 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35770609
export const use_game_skin = createAsyncThunk(
  'LudoSkin_use_mall_game_skin',
  async (arg: {room_id: number; pid: number; type: typeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/gamestore/common/use_mall_game_skin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        game_tag: 'ludo',
      }
    )
    return resp.data.data
  }
)

// 领取任务奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35755965
export const cold_boot_activity_reward = createAsyncThunk(
  'LudoSkin_cold_boot_activity_reward',
  async (arg: {mission_id: number; room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        cold_boot_activity?: {
          List?: Array<MissionActivityItemSt>
        }
        reward?: {
          img_url: string
          reward_cnt: number
          reward_msg: string
        }
      }>
    >('/gamestore/ludo/cold_boot_activity_reward', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)
// 冷启活动任务去完成 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35763526
export const cold_boot_goto_complete = createAsyncThunk(
  'LudoSkin_cold_boot_goto_complete',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        room_id: number
        msg: string
      }>
    >('/gamestore/ludo/cold_boot_goto_complete', {
      ...store.getState().env.deviceinfo,
      game_id: ENV === 'production' ? 600001 : 600003,
      ...arg,
    })
    return resp.data.data
  }
)

export enum stateEnum {
  noUse = 0,
  using,
  canUse,
  expired,
}
enum typeEnum {
  //  1骰子皮肤 2棋子皮肤
  dice = 1,
  chessman,
}
export interface game_skin_type {
  id: number
  icon: string
  title: string
  state: stateEnum
  tag: string
  expire_day: number
  type: typeEnum
  pid: number
}
export enum missionStatus {
  goDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardEnum {
  silverCoin = 7,
  skin,
}
interface MissionActivityItemSt {
  mission_id: number
  reward: {
    img_url: string
    reward_cnt: number
    is_box: boolean
    reward_type?: rewardEnum
  }
  status: missionStatus
  desc: string
  target: number
  current: number
}
interface InitialStateType {
  // 背包列表
  list?: Array<{game_skin?: game_skin_type}>
  tips?: string
  // 任务列表
  cold_boot_activity?: {
    list?: Array<MissionActivityItemSt>
  }
  activity_time?: string
}

const initialState: InitialStateType = {}

export const LudoSkinSlice = createSlice({
  name: 'LudoSkin',
  initialState,
  reducers: {
    // changeGiftStatucs: (state, action: PayloadAction<boolean>) => {
    //   Object.assign(state, {
    //     is_receive: action.payload,
    //   })
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(knapsack_list.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })

    builder.addCase(cold_boot_activity.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(cold_boot_activity_reward.fulfilled, (state, action) => {
      if (action.payload.cold_boot_activity && !action.payload.err_msg) {
        Object.assign(state, {
          cold_boot_activity: action.payload.cold_boot_activity,
        })
      }
    })
  },
})
export default LudoSkinSlice.reducer
export const LudoSkinActions = LudoSkinSlice.actions
